const superagent = require('superagent');

// Set a session if you want to use it for testing
// sessionStorage.setItem('token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOjQ2LCJleHAiOjE1Mzg3NjU4NDd9.KtoMpEm5bADlFdHFFwX-B1icUDd8qkrHlHxxOQSBLn8')
var unauthorizedRedirect = function(req) {
    req.on('response', function (res) {
        if (res.req.url === '/api/user' && res.status === 401) {
            window.localStorage.removeItem('token');
            location.href = '/login';
        }
    });
};

const requests = {
    get: url => {
        return superagent
            .get(url)
            .set('Authorization', `Token ${window.localStorage.getItem('token')}`)
            .use(unauthorizedRedirect)
    },
    post: url => {
        return superagent
            .post(url)
            .set('Authorization', `Token ${window.localStorage.getItem('token')}`)
            .use(unauthorizedRedirect)
    },
    put: url => {
        return superagent
            .put(url)
            .set('Authorization', `Token ${window.localStorage.getItem('token')}`)
            .use(unauthorizedRedirect)
    },
    delete: url => {
        return superagent
            .delete(url)
            .set('Authorization', `Token ${window.localStorage.getItem('token')}`)
            .use(unauthorizedRedirect)
    }
}

module.exports = requests;


// WEBPACK FOOTER //
// ./src/utils/agent.js